import useSWR from 'swr'
import invariant from 'tiny-invariant'

import { isSuperFetchError, superFetch } from '~/api-client'
import { UserResponse, UsersResponse } from '~/api-definition/response'
import { config } from '~/config'
import { useAccessToken } from '~/provider/SessionProvider'

export const userGetInvitedUser = (args: {
  searchParams:
    | {
        user_id: string
      }
    | { user_name: string }
}) => {
  return superFetch<UserResponse>(
    config.api.url('/user/invited_user', {
      searchParams: args.searchParams,
    })
  )
}

export const userGetInvitedUsers = (args: { accessToken: string }) => {
  return superFetch<UsersResponse>(config.api.url('/user/invited_users'), {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${args.accessToken}`,
    },
  })
}

export const userGetRookieUsers = (args: { accessToken: string }) => {
  return superFetch<UsersResponse>(config.api.url('/user/rookie_users'), {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${args.accessToken}`,
    },
  })
}

// Hooks

export const useUserInvitedUser = (args: {
  searchParams: { user_id: string } | { user_name: string }
}) => {
  return useSWR(
    config.api.url('/user/invited_user', { searchParams: args.searchParams }),
    async () => {
      try {
        return await userGetInvitedUser(args)
      } catch (error) {
        if (isSuperFetchError(error) && error.response.status === 404) {
          return undefined
        } else {
          throw error
        }
      }
    }
  )
}

export const useUserRookieUsers = () => {
  const accessToken = useAccessToken({ loginRequired: true })
  return useSWR(
    accessToken == null ? null : config.api.url('/user/rookie_users'),
    () => {
      invariant(accessToken != null)
      return userGetRookieUsers({
        accessToken,
      })
    }
  )
}
